export default {
  activation: 'activation',
  attributionError: 'attributionError',
  serviceUnavailable: 'serviceUnavailable',
};
